// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.query.FindQueriesRequest */
/* istanbul ignore next */
@GandalfModel
export class FindQueriesRequest extends GandalfModelBase {

	@GandalfConstantDecorator(constants.CustomReportsMasterCategory)
	@GandalfProperty({ designType: constants.CustomReportsMasterCategory })
	customReportsMasterCategory!: constants.CustomReportsMasterCategory | null;

	@GandalfConstantDecorator(constants.QueryTemplateCategory)
	@GandalfValidator({ notNull: { message: 'Template category is required.' } })
	@GandalfProperty({ designType: constants.QueryTemplateCategory, isRequired: true })
	templateCategory!: constants.QueryTemplateCategory;

}
